export const SERVER_URL_GLOBAL = 'http://www2.douane.gov.ma/rest/';